import { Badge, Button, Col, Container, Row } from "react-bootstrap";
import { useCallback, useRef, useState } from "react";
import { BarcodeGenerator } from "./BarcodeGenerator";
import { BarcodeScanner } from "./BarcodeScanner";

export const BarcodeDemo = () => {
    const [scans, setScans] = useState<string[]>([]);
    const [textToEncode, setTextToEncode] = useState("Hello World!");
    const [showModal, setShowModal] = useState(false);

    const videoRef = useRef<HTMLVideoElement>(null);

    const onScan = useCallback((result: string) => {
        setScans((prev) => [...prev, result]);
    }, []);

    const onError = useCallback((err: unknown) => {
        console.error(err);
    }, []);

    const onHide = useCallback(() => {
        setShowModal(false);
    }, []);

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <h2>Generate Data Matrix</h2>
                <input
                    style={{ marginBottom: 20 }}
                    type="text"
                    value={textToEncode}
                    onChange={(e) => setTextToEncode(e.target.value)}
                />
                <BarcodeGenerator data={textToEncode} />
            </div>
            <div className="mx-2">
                <Container>
                    <Row>
                        <Col>
                            <Button onClick={() => setShowModal(true)}>Start Scanning</Button>
                        </Col>
                        <Col>
                            <Button onClick={() => setScans([])}>Clear Scans</Button>
                        </Col>
                    </Row>
                </Container>
                <BarcodeScanner
                    onError={onError}
                    onHide={onHide}
                    onResult={onScan}
                    ref={videoRef}
                    show={showModal}
                    title={
                        <>
                            Scanned <Badge bg="secondary">{scans.length}</Badge>
                        </>
                    }
                />
                <div className="mt-3">
                    <p>Scans:</p>
                    <ul>
                        {scans.map((s, i) => (
                            <li key={i}>{s}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
